import React, { useEffect, useState } from "react";
import { act } from "react";

export default function FakeInput(props) {

    const {
        onChange = () => {},
        name = "",
        width = 50,
        keyboard = false,
        keyboardInput = "",
        setKeyboard = () => { },
        placeholder = "Scan / Enter",
        value = "",
        setInput = () => { },
        number = false,
        doneTrigger = false
    } = props;


    const active = (keyboard === name);

    const [v, setV] = useState("");
    const [selected, setSelected] = useState(true);


    useEffect(() => {
        if (keyboard !== name) { 
            setSelected(true);
         }
        if (active) {
            setV(value)
        }
    }, [value])


    const load = () => {
        if (!active) {
            setKeyboard(name);
            setInput(v);
        }
    }

    useEffect(() => {
        if (active) {
            onChange(v);
            setInput("");
            setV("")
            setKeyboard("");
        }
    }, [doneTrigger])


    return (
        <div onClick={() => load(name)} style={{ "width": width + "px" }} className={(active) ? "fake-input active" : "fake-input"}>
            {(active && v)}
            {((!active || !value) && <span style={{ "opacity": (v) ? "1" : "0.5" }}>{(v) ? v : placeholder}</span>)}
        </div>
    )

}